import React from 'react';
import _ from 'underscore';

type NativeTextInputProps = React.InputHTMLAttributes<HTMLInputElement>;

export type TextInputValue = NonNullable<NativeTextInputProps['value']>;

export interface ITextInputProps {
  className?: NativeTextInputProps['className'] | null;
  placeholder?: NativeTextInputProps['placeholder'] | null;
  id?: NativeTextInputProps['id'] | null;
  name?: NativeTextInputProps['name'] | null;
  onChange: NonNullable<NativeTextInputProps['onChange']>;
  onClick?: NativeTextInputProps['onClick'];
  onBlur?: NativeTextInputProps['onBlur'];
  value: TextInputValue;
  disabled?: NativeTextInputProps['disabled'];
  ariaLabel?: React.AriaAttributes['aria-label'] | null;
}

export function TextInput(props: ITextInputProps) {
  const id = props.id ? props.id : _.uniqueId('input-');

  return (
    <input
      type="text"
      className={props.className}
      placeholder={props.placeholder}
      name={props.name}
      id={id}
      value={props.value}
      onChange={props.onChange}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props.ariaLabel || props.placeholder}
      onBlur={props.onBlur}
    />
  );
}

TextInput.defaultProps = {
  className: null,
  placeholder: null,
  id: null,
  name: null,
  disabled: false,
  ariaLabel: null,
  onClick: _.noop,
  onBlur: _.noop,
};
